const LeaderShipRoutes = {
  createLeader: "/createLeader",
  getLeader: "/getLeader",
  deleteLeader: "/deleteLeader",
  updateLeader: "/updateLeader",
};

export default LeaderShipRoutes;
